import { Button } from "components/atoms";
import { useAddTopicFocusToCourseworkMutation } from "services/topicFocus";

interface IProps {
  item: any;
}

export const InstructorListButtonMobile = ({ item }: IProps) => {

  const [addToCoursework, { isLoading }] =
  useAddTopicFocusToCourseworkMutation();

  const handleClick = async (id: any) => {
    try {
      await addToCoursework({ segmentId: id, page: 1 }).unwrap();
    } catch (error) {
      console.log("error : ", error);
    }
  };
  return (
    <Button
      styles="add-to-coursework-btn"
      icon={false}
      label="Add to Course Work"
      type="planner"
      onClick={() => handleClick(item.ProductOfferingSegmentId)}
      isLoading={isLoading}
    />
  );
};
